module.exports = __webpack_public_path__ + "static/img/kit_101-671-399-647.7ddc3c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/kit_101-671-399-647.jpg
// module id = 0vsN
// module chunks = 0